import { render, staticRenderFns } from "./InboxView.vue?vue&type=template&id=59c82b3c&scoped=true"
import script from "./InboxView.vue?vue&type=script&lang=js"
export * from "./InboxView.vue?vue&type=script&lang=js"
import style0 from "./InboxView.vue?vue&type=style&index=0&id=59c82b3c&prod&scoped=true&lang=css"
import style1 from "./InboxView.vue?vue&type=style&index=1&id=59c82b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c82b3c",
  null
  
)

export default component.exports